module.exports = __webpack_public_path__ + "static/media/MeazureApp-logo-RGB-white.b6f2450d.png";